module.exports = __webpack_public_path__ + "img/21c8cf9ebb1f40d9855d248b02eabda6-640.8170223e.jpg";